import React, { useEffect, useState } from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import { getShiftList } from "adminApi/DutyRosterApi/ShiftApi";

const EditRosterForm = ({
    fields = [],
    values = {},
    errors = {},
    handleChange = () => { },
    handleSubmit = () => { },
    loading = false,
    title = "Edit Duty Roster"
}) => {
    const [shifts, setShifts] = useState([]);

    // Fetch shifts for the dropdown
    useEffect(() => {
        const fetchShifts = async () => {
            try {
                const res = await getShiftList({ page: 1, limit: 100 });
                if (res.success && res.data) {
                    const shiftOptions = res.data.map((shift) => ({
                        value: shift.shift_id,
                        label: shift.shift_name,
                    }));
                    setShifts(shiftOptions);
                }
            } catch (err) {
                console.error("Failed to fetch shifts", err);
            }
        };
        fetchShifts();
    }, []);

    const renderField = (field) => {
        switch (field.type) {
            case "select":
                return (
                    <FormSelect
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        options={field.name === "shift_id" ? shifts : field.options || []}
                        error={errors[field.name]}
                    />
                );
            case "date":
                return (
                    <FormDatePicker
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                        dateFormat="Y-m-d"
                    />
                );
            default:
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
        }
    };

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>{title}</HeadingOne>}>
            {fields.map(renderField)}

            <FormSubmitButton
                label="Update"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditRosterForm;
